angular.module('pitch.app')
.controller('MainMenuCtrl', function($scope, $controller, SiteContext, $state, fcDropnavCtrl, $window, Auth) {
    "use strict";

    angular.extend(this, $controller('AccountMenuCtrl', {
        $scope: $scope
    }));

    $scope.$state = $state;

    $scope.logout = function() {
        Auth.logout().then(function() {
            $state.go('home', {}, { reload: true });
        });
    };

    $scope.close = function(e) {
        fcDropnavCtrl.set(false);
    };
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/MainMenuCtrl.js